import {
  Box,
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';

const Recruit = () => {
  const data = [
    { title: '雇用形態', value: '正社員' },
    { title: '募集職種', value: '・システムエンジニアリングサービス　SE、PG・開発、インフラジャンル問わず、若手(経験1年以上)～即戦力まで幅広く' },
    { title: '歓迎', value: '・将来的に自社サービスの企画立案・プロジェクト推進を実行する意欲のある方・組織の中核人材として会社の成長をリードしていく方' },
    { title: '勤務地', value: '関東圏　参画案件次第' },
    { title: '休日', value: '完全週休2日制（土・日）、祝日、有給休暇' },
    { title: '給与', value: '参画案件により給与変動' },
    { title: '福利厚生', value: '各種社会保険完備（健康保険、厚生年金保険、労災保険、雇用保険）交通費支給 リモートワーク補助金 会社負担生命保険加入制度' },
  ];

  return (
    <Container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '30px',
        height: '100vh',
        textAlign: 'center',
        padding: '16px', // スマホでの余白調整
      }}
    >
      <Box sx={{ width: '100%', maxWidth: '600px' }}> {/* 最大幅を設定 */}
        <Typography variant="h4" gutterBottom sx={{ fontFamily: "'Noto Serif JP', serif" }}>
          Recruit
        </Typography>
        <Typography gutterBottom variant="h5" component="div">
          採用
        </Typography>
        <Table
          sx={{
            width: '100%', // 幅を100%に設定
          }}
        >
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{
                    fontSize: {xs: '10px', md: '18px' },
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                    width: '30%',
                  }}
                >
                  {item.title}
                </TableCell>
                <TableCell sx={{ fontSize: {xs: '10px', md: '18px' } }}>
                  {item.title === '歓迎' || item.title === "募集職種" ? (
                    item.value
                      .split('・')
                      .filter(val => val.trim() !== '') // 空文字を除外
                      .map((val, i) => (
                        <Typography key={i} variant="body2" sx={{ marginBottom: '4px', fontSize: '15px', textAlign: 'left' }}>
                          {val}
                        </Typography>
                      ))
                  ) : (
                    item.value
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Container>
  );
};

export default Recruit;  
